function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import { useStore } from "react-redux";
import React from "react";

var withStore = function withStore(Component) {
  return function (props) {
    var store = useStore();
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      store: store
    }));
  };
};

export default withStore;